var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n    Enclosures of every type and size to fit your project goals can be custom-designed, manufactured and installed at\n    your location.\n  ")]),_c('carousel',{attrs:{"item":"enclosures","images":_vm.images}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }